import React, { useState } from "react";
import Button from "../../button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../UserfulConfirmationDialog";
import Input from "../../Input/Input";
import { NetworkStaticRouteConfig } from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { UserfulTooltip } from "../..";

interface IProps {
    routes: NetworkStaticRouteConfig[];
    connectionUUID: StringID;
    type: "dropdown" | "button";
    onDelete: (e) => void;
    addiotnalSecurity?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    hideTrigger?: boolean;
}

export default function DeleteRoutes(props: IProps) {
    const { t } = useTranslation();

    const isControlled = props.open !== undefined;
    const [showInternal, setShowInternal] = useState(false);
    const show = isControlled ? !!props.open : showInternal;
    const [input, setInput] = useState<string>("");

    if (props.routes.length === 0) return null;

    const additionalRoutes = props.routes.length - 1;

    const setShowState = (next: boolean) => {
        if (isControlled) {
            props.onOpenChange?.(next);
        } else {
            setShowInternal(next);
        }
    };

    return (
        <>
            {!props.hideTrigger && props.type === "dropdown" && (
                <Dropdown.Item onClick={(e) => setShowState(true)}>
                    <div className="userful-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>{additionalRoutes > 1 ? t("Shared.deleteAll") : t("Shared.delete")}</p>
                </Dropdown.Item>
            )}
            {!props.hideTrigger && props.type === "button" && (
                <UserfulTooltip title={additionalRoutes > 1 ? t("Shared.deleteAll") : t("Shared.delete")}>
                    <Button variant="secondary" iconOnly onClick={() => setShowState(true)}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </UserfulTooltip>
            )}

            <UserfulConfirmationDialog
                show={show}
                icon={{ icon: faCircleExclamation, color: "#D13E2C" }}
                onCancel={() => setShowState(false)}
                title={t("Shared.delete") + " " + additionalRoutes ? t("Shared.routes") : t("Shared.route")}
                replaceBody={
                    <>
                        <p>
                            {t("Shared.deleteStart")} <strong>Static Route</strong>
                            {additionalRoutes > 0 && <strong className="userful-tag">+{additionalRoutes}</strong>}?{" "}
                            {t("Shared.deleteEnd")}
                        </p>
                        {props.addiotnalSecurity && (
                            <>
                                <Input
                                    filedTitle={t("Shared.deleteConfirmation")}
                                    value={input}
                                    onChange={(e) => {
                                        setInput(e.target.value);
                                    }}
                                />
                            </>
                        )}
                    </>
                }
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={() => setShowState(false)}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button
                            variant="danger"
                            disabled={props.addiotnalSecurity && input !== "DELETE"}
                            onClick={(e) => {
                                props.onDelete(e);
                                setShowState(false);
                            }}
                        >
                            {additionalRoutes > 0 ? t("Shared.deleteAll") : t("Shared.delete")}
                        </Button>
                    </>
                }
            />
        </>
    );
}
